<template>
  <head>
    <meta charset="utf-8" />
    <title>Desk Birdy | Invoice Waivers</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Rental management system by Nouveta LTD" name="description" />
    <meta content="Kelvin Njuguna" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css" />

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->

    <!-- owl.carousel css -->
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.carousel.min.css">
    <link rel="stylesheet" href="assets/libs/owl.carousel/assets/owl.theme.default.min.css">

    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />


  </head>

  <body data-sidebar="dark">
  <!-- Loading overlay -->
  <div v-if="loading" class="loading-overlay">
    <div class="text-center">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <p class="mt-3 text-muted">Processing your request...</p>
    </div>
  </div>

  <!-- Begin page -->
  <div id="layout-wrapper">
    <!-- ========== Left Sidebar Start ========== -->
    <NavigationBar/>
    <!-- Left Sidebar End -->

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div class="main-content">
      <div class="page-content">
        <div class="container-fluid">


          <!-- tool bar -->
          <ToolBarWaiver/>
          <!-- end of toolbar -->

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <div>
                  <h4 class="mb-sm-0 font-size-18">Invoice Waivers</h4>
                  <p class="text-muted mb-0">Manage and track approved invoice waivers</p>
                </div>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Dashboards</a></li>
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Action Center</a></li>
                    <li class="breadcrumb-item active">Waivers</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- Filter Section -->
          <div class="filter-section">
            <div class="row g-3">
              <div class="col-md-4">
                <div class="search-box">
                  <div class="position-relative">
                    <input
                        v-model="search"
                        type="text"
                        class="form-control"
                        placeholder="Search by invoice number, customer..."
                        @keyup.enter="getWaivers"
                    >
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div>

              <div class="col-md-2">
                <select class="form-select" v-model="subCounty" @change="getWaivers(subCounty.subCountyName)">
                  <option selected="" value="">All Sub Counties</option>
                  <option :key="index" :value="item" v-for="(item, index) in subCounties">
                    {{ item.subCountyName }}
                  </option>
                </select>
              </div>

              <div class="col-md-2">
                <div class="date-range-wrapper">
                  <input
                      v-model="dateFrom"
                      class="form-control"
                      type="date"
                      :max="getCurrentDate()"
                      placeholder="From"
                  >
                </div>
              </div>

              <div class="col-md-2">
                <div class="date-range-wrapper">
                  <input
                      v-model="dateTo"
                      class="form-control"
                      type="date"
                      :min="dateFrom"
                      :max="getCurrentDate()"
                      placeholder="To"
                  >
                </div>
              </div>

              <div class="col-md-2">
                <button
                    @click="downloadWaivers"
                    class="btn btn-primary w-100 action-btn"
                    :disabled="download !== 'Download Report'"
                >
                  <i class="bx bxs-download me-2"></i>
                  <span>{{ download }}</span>
                </button>
              </div>
            </div>
          </div>

          <!-- Main Content -->
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-body">
                  <!-- Stats Summary -->
                  <div class="row mb-4" v-if="waiverRequests.length > 0">
                    <div class="col-md-3">
                      <div class="info-card">
                        <h6 class="text-muted mb-2">Total Waivers</h6>
                        <h3 class="mb-0">{{ waiverRequests.length }}</h3>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="info-card">
                        <h6 class="text-muted mb-2">Total Amount Waived</h6>
                        <h3 class="mb-0 text-primary">KES {{ totalWaivedAmount.toLocaleString() }}</h3>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="info-card">
                        <h6 class="text-muted mb-2">Avg. Waiver Amount</h6>
                        <h3 class="mb-0">KES {{ avgWaiverAmount.toLocaleString() }}</h3>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="info-card">
                        <h6 class="text-muted mb-2">Period</h6>
                        <h3 class="mb-0">{{ periodDisplay }}</h3>
                      </div>
                    </div>
                  </div>

                  <!-- Table -->
                  <div class="table-responsive" v-if="waiverRequests.length > 0">
                    <table class="table table-hover">
                      <thead class="table-light">
                      <tr>
                        <th>Date</th>
                        <th>Invoice #</th>
                        <th>Customer</th>
                        <th>Waiver Reason</th>
                        <th>Waiver Item</th>
                        <th class="text-end">Waiver Amount</th>
                        <th>Invoice Details</th>
                        <th>Status</th>
                        <th class="text-center">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item, index) in waiverRequests" :key="index">
                        <td>
                          <div>{{ formatDate(item.dateCreated) }}</div>
                          <small class="text-muted">{{ formatTime(item.dateCreated) }}</small>
                        </td>
                        <td>
                          <span class="fw-bold">{{ item.billNo }}</span>
                        </td>
                        <td>{{ item.invoicedTo }}</td>
                        <td>
                              <span class="info-tooltip" :title="item.reason">
                                {{ truncateText(item.reason, 30) }}
                              </span>
                        </td>
                        <td class="fw-bold">{{ item.description }}</td>
                        <td class="text-end">
                          <span class="fw-bold text-primary">KES {{ formatCurrency(item.amount) }}</span>
                        </td>
                        <td>
                          <small class="text-muted">
                            Invoice: KES {{ formatCurrency(item.invoicedAmount) }}<br>
                            Paid: KES {{ formatCurrency(item.amountPaid) }}<br>
                            Balance: KES {{ formatCurrency(item.invoiceBalance) }}
                          </small>
                        </td>
                        <td>
                              <span class="status-badge approved">
                                <i class="bx bx-check-circle me-1"></i> Approved
                              </span>
                        </td>
                        <td>
                          <div class="btn-action-group justify-content-center">
                            <button
                                @click="viewWaiverRequest(item)"
                                class="btn btn-sm btn-success action-btn"
                                data-bs-toggle="modal"
                                data-bs-target="#otpModalWaiver"
                                title="View Details"
                            >
                              <i class="bx bx-show me-1"></i> View
                            </button>
                            <button
                                @click="printBill(item.billNo)"
                                class="btn btn-sm btn-primary action-btn"
                                title="Print Invoice"
                            >
                              <i class="bx bx-printer me-1"></i> Print
                            </button>
                            <button
                                v-if="getRight('REVERT WAIVER')"
                                @click="viewWaiverRequest(item)"
                                class="btn btn-sm btn-warning action-btn"
                                data-bs-toggle="modal"
                                data-bs-target="#waiverDecline"
                                title="Revert Waiver"
                            >
                              <i class="bx bx-undo me-1"></i> Revert
                            </button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- Empty State -->
                  <div v-else class="empty-state">
                    <img src="assets/images/no-data.svg" alt="No data">
                    <h5 class="text-muted">No Waivers Found</h5>
                    <p class="text-muted">
                      {{ search || dateFrom || dateTo || subCountyName ? 'Try adjusting your filters' : 'There are no approved waivers to display' }}
                    </p>
                    <button v-if="search || dateFrom || dateTo || subCountyName" @click="clearFilters" class="btn btn-primary">
                      Clear Filters
                    </button>
                  </div>

                  <!-- Pagination -->
                  <div class="row mt-4" v-if="totalPages > 1 && waiverRequests.length > 0">
                    <div class="col-sm-12 col-md-5">
                      <div class="dataTables_info">
                        Showing {{ startRecord }} to {{ endRecord }} of {{ totalRecords }} entries
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-7">
                      <div class="dataTables_paginate paging_simple_numbers float-end">
                        <ul class="pagination pagination-rounded mb-0">
                          <!-- First Page -->
                          <li class="paginate_button page-item first" :class="{ disabled: currentPage === 1 }">
                            <a href="javascript: void(0);" @click.prevent="changePage(1)" class="page-link" title="First page">
                              <i class="mdi mdi-chevron-double-left"></i>
                            </a>
                          </li>

                          <!-- Previous Page -->
                          <li class="paginate_button page-item previous" :class="{ disabled: currentPage === 1 }">
                            <a href="javascript: void(0);" @click.prevent="changePage(currentPage - 1)" class="page-link" title="Previous page">
                              <i class="mdi mdi-chevron-left"></i>
                            </a>
                          </li>

                          <!-- Page Numbers -->
                          <li v-if="showStartEllipsis" class="paginate_button page-item disabled">
                            <a href="javascript: void(0);" class="page-link">...</a>
                          </li>

                          <li v-for="page in displayPages" :key="page" class="paginate_button page-item" :class="{ active: page === currentPage }">
                            <a href="javascript: void(0);" @click.prevent="changePage(page)" class="page-link">{{ page }}</a>
                          </li>

                          <li v-if="showEndEllipsis" class="paginate_button page-item disabled">
                            <a href="javascript: void(0);" class="page-link">...</a>
                          </li>

                          <!-- Next Page -->
                          <li class="paginate_button page-item next" :class="{ disabled: currentPage === totalPages }">
                            <a href="javascript: void(0);" @click.prevent="changePage(currentPage + 1)" class="page-link" title="Next page">
                              <i class="mdi mdi-chevron-right"></i>
                            </a>
                          </li>

                          <!-- Last Page -->
                          <li class="paginate_button page-item last" :class="{ disabled: currentPage === totalPages }">
                            <a href="javascript: void(0);" @click.prevent="changePage(totalPages)" class="page-link" title="Last page">
                              <i class="mdi mdi-chevron-double-right"></i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <!-- Page Size Selector -->
                  <div class="row mt-3" v-if="waiverRequests.length > 0">
                    <div class="col-sm-12 col-md-6">
                      <div class="dataTables_length">
                        <label class="d-flex align-items-center">
                          Show
                          <select v-model="pageSize" @change="changePageSize" class="form-select form-select-sm mx-2" style="width: auto;">
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="1000">1000</option>
                            <option value="10000000">All</option>
                          </select>
                          entries
                        </label>
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-6">
                      <div class="text-end">
                        <small class="text-muted">
                          Page {{ currentPage }} of {{ totalPages }}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <!-- View Waiver Modal -->
      <div class="modal fade" id="otpModalWaiver" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Waiver Details</h4>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div v-if="waiverDetails && waiverRequest" class="modal-body">
              <!-- Invoice Information -->
              <div class="info-card mb-3">
                <h5 class="mb-3 text-primary">
                  <i class="bx bx-receipt me-2"></i>Invoice Information
                </h5>
                <div class="row g-3">
                  <div class="col-md-6">
                    <label class="text-muted small">Invoice Number</label>
                    <p class="fw-bold mb-2">{{ waiverRequest.billNo }}</p>
                  </div>
                  <div class="col-md-6">
                    <label class="text-muted small">Customer</label>
                    <p class="fw-bold mb-2">{{ waiverRequest.customerName || waiverRequest.invoicedTo }}</p>
                  </div>
                  <div class="col-md-6">
                    <label class="text-muted small">Invoice Date</label>
                    <p class="mb-2">{{ formatDate(waiverRequest.invoicedDate) }}</p>
                  </div>
                  <div class="col-md-6">
                    <label class="text-muted small">Invoice Amount</label>
                    <p class="mb-2">KES {{ formatCurrency(waiverRequest.invoicedAmount) }}</p>
                  </div>
                  <div class="col-md-6">
                    <label class="text-muted small">Amount Paid</label>
                    <p class="mb-2 text-success">KES {{ formatCurrency(waiverRequest.amountPaid) }}</p>
                  </div>
                  <div class="col-md-6">
                    <label class="text-muted small">Balance</label>
                    <p class="mb-2 text-warning">KES {{ formatCurrency(waiverRequest.invoiceBalance) }}</p>
                  </div>
                </div>
              </div>

              <!-- Waiver Information -->
              <div class="info-card">
                <h5 class="mb-3 text-primary">
                  <i class="bx bx-info-circle me-2"></i>Waiver Information
                </h5>
                <div class="row g-3">
                  <div class="col-md-6">
                    <label class="text-muted small">Waived Item</label>
                    <p class="fw-bold mb-2">{{ waiverRequest.feeDescription || waiverRequest.description }}</p>
                  </div>
                  <div class="col-md-6">
                    <label class="text-muted small">Waiver Amount</label>
                    <p class="fw-bold mb-2 text-primary">KES {{ formatCurrency(waiverRequest.amount) }}</p>
                  </div>
                  <div class="col-md-12">
                    <label class="text-muted small">Reason for Waiver</label>
                    <p class="mb-2">{{ waiverRequest.reason }}</p>
                  </div>
                  <div class="col-md-6">
                    <label class="text-muted small">Initiated By</label>
                    <p class="mb-2">{{ waiverRequest.initiatedBy }}</p>
                  </div>
                  <div class="col-md-6">
                    <label class="text-muted small">Date Initiated</label>
                    <p class="mb-2">{{ formatDateTime(waiverRequest.dateCreated) }}</p>
                  </div>
                </div>
              </div>

              <!-- Action Buttons -->
              <div class="mt-4 d-flex justify-content-end gap-2">
                <button @click="printBill(waiverRequest.billNo)" class="btn btn-primary">
                  <i class="bx bx-printer me-2"></i>Print Invoice
                </button>
                <button type="button" data-bs-dismiss="modal" class="btn btn-secondary">
                  Close
                </button>
              </div>
            </div>

            <!-- Success State -->
            <div v-if="successWaiver" class="modal-body text-center py-5">
              <i class="bx bx-check-circle success-icon"></i>
              <h4 class="mt-3">Waiver Successfully Processed</h4>
              <p class="text-muted mt-2">
                The waiver for invoice <strong>{{ waiverRequest.billNo }}</strong>
                has been successfully processed.
              </p>
              <div class="mt-4">
                <button @click="printBill(waiverRequest.billNo)" class="btn btn-primary me-2">
                  <i class="bx bx-printer me-2"></i>Print Invoice
                </button>
                <button type="button" data-bs-dismiss="modal" @click="resetModal" class="btn btn-secondary">
                  Close
                </button>
              </div>
            </div>

            <!-- Error State -->
            <div v-if="failedWaiver" class="modal-body text-center py-5">
              <i class="mdi mdi-alert-circle error-icon"></i>
              <h4 class="mt-3 text-danger">Waiver Processing Failed</h4>
              <p class="text-muted mt-2">
                {{ message || 'An error occurred while processing the waiver. Please try again.' }}
              </p>
              <div class="mt-4">
                <button @click="retryWaiverAction" class="btn btn-primary me-2">
                  <i class="bx bx-refresh me-2"></i>Retry
                </button>
                <button type="button" data-bs-dismiss="modal" @click="resetModal" class="btn btn-secondary">
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Revert Waiver Modal -->
      <div class="modal fade" id="waiverDecline" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header bg-warning bg-opacity-10">
              <h4 class="modal-title">
                <i class="bx bx-undo me-2"></i>Revert Waiver
              </h4>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div v-if="waiverDetails && waiverRequest" class="modal-body">
              <!-- Warning Alert -->
              <div class="alert alert-warning d-flex align-items-center" role="alert">
                <i class="bx bx-info-circle fs-4 me-2"></i>
                <div>
                  <strong>Important:</strong> Reverting this waiver will restore the original invoice amount.
                  This action requires OTP verification.
                </div>
              </div>

              <!-- Waiver Summary -->
              <div class="info-card">
                <h5 class="mb-3">Waiver Summary</h5>
                <div class="row g-3">
                  <div class="col-md-6">
                    <label class="text-muted small">Invoice Number</label>
                    <p class="fw-bold">{{ waiverRequest.billNo }}</p>
                  </div>
                  <div class="col-md-6">
                    <label class="text-muted small">Customer</label>
                    <p class="fw-bold">{{ waiverRequest.customerName || waiverRequest.invoicedTo }}</p>
                  </div>
                  <div class="col-md-6">
                    <label class="text-muted small">Waived Amount</label>
                    <p class="fw-bold text-primary">KES {{ formatCurrency(waiverRequest.amount) }}</p>
                  </div>
                  <div class="col-md-6">
                    <label class="text-muted small">Current Invoice Balance</label>
                    <p class="fw-bold">KES {{ formatCurrency(waiverRequest.invoiceBalance) }}</p>
                  </div>
                </div>
              </div>

              <!-- Reason Input -->
              <div class="mb-4">
                <label class="form-label">
                  Reason for Reverting <span class="text-danger">*</span>
                </label>
                <textarea
                    v-model="reason"
                    class="form-control"
                    rows="3"
                    placeholder="Please provide a detailed reason for reverting this waiver..."
                    required
                ></textarea>
                <div class="form-text">This reason will be logged for audit purposes.</div>
              </div>

              <!-- OTP Verification -->
              <div class="alert alert-info">
                <h6 class="alert-heading">
                  <i class="bx bx-lock-alt me-2"></i>OTP Verification Required
                </h6>
                <p class="mb-3">
                  An OTP has been sent to your registered phone number:
                  <strong>{{ formatPhoneNumber(sessionPhoneNumber) }}</strong>
                </p>
                <div class="input-group">
                  <input
                      v-model="otpCodes"
                      type="text"
                      class="form-control otp-input"
                      placeholder="Enter OTP"
                      maxlength="6"
                      @keyup.enter="verifyOTP('REVERTED')"
                  >
                  <button
                      @click="sendOTPMessage"
                      type="button"
                      class="btn btn-outline-primary"
                      :disabled="resendTimer > 0"
                  >
                    {{ resendTimer > 0 ? `Resend in ${resendTimer}s` : 'Resend OTP' }}
                  </button>
                </div>
              </div>

              <!-- Action Buttons -->
              <div class="d-flex justify-content-end gap-2 mt-4">
                <button
                    type="button"
                    data-bs-dismiss="modal"
                    class="btn btn-light"
                >
                  Cancel
                </button>
                <button
                    @click="verifyOTP('REVERTED')"
                    :disabled="!canSubmitRevert"
                    class="btn btn-warning"
                >
                    <span v-if="!loading">
                      <i class="bx bx-undo me-2"></i>Confirm Revert
                    </span>
                  <span v-else>
                      <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                      Processing...
                    </span>
                </button>
              </div>
            </div>

            <!-- Success State -->
            <div v-if="successWaiver" class="modal-body text-center py-5">
              <div class="mb-4">
                <i class="bx bx-check-circle success-icon text-warning"></i>
              </div>
              <h4>Waiver Successfully Reverted</h4>
              <p class="text-muted mt-2">
                The waiver for invoice <strong>{{ waiverRequest.billNo }}</strong>
                has been successfully reverted. The original invoice amount has been restored.
              </p>
              <div class="mt-4">
                <button @click="printBill(waiverRequest.billNo)" class="btn btn-primary me-2">
                  <i class="bx bx-printer me-2"></i>View Updated Invoice
                </button>
                <button type="button" data-bs-dismiss="modal" @click="resetModal" class="btn btn-secondary">
                  Close
                </button>
              </div>
            </div>

            <!-- Error State -->
            <div v-if="failedWaiver" class="modal-body text-center py-5">
              <div class="mb-4">
                <i class="mdi mdi-alert-circle error-icon"></i>
              </div>
              <h4 class="text-danger">Revert Failed</h4>
              <p class="text-muted mt-2">
                {{ message || 'Unable to revert the waiver. Please check the invoice status and try again.' }}
              </p>
              <div class="mt-4">
                <button @click="retryRevertAction" class="btn btn-warning me-2">
                  <i class="bx bx-refresh me-2"></i>Try Again
                </button>
                <button type="button" data-bs-dismiss="modal" @click="resetModal" class="btn btn-secondary">
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">
              © {{ new Date().getFullYear() }} Desk Birdy
            </div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                County Billing System v2.0
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <!-- end main content-->
  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay"></div>
  </body>
</template>

<script>
/* eslint-disable */
import {authUrl, biller, execute, executeDownload, getRight, trade} from "@/api";
import NavigationBar from "@/components/Navigation";
import router from "@/router";
import ToolBar from "@/components/sbp/ToolBar";
import moment from "moment";
import ToolBarWaiver from "@/components/waiver/ToolBarWaiver.vue";

export default {
  name: "WaiverPending",
  components: {ToolBarWaiver, ToolBar, NavigationBar},
  data() {
    return {
      waiverDetails: true,
      successWaiver: false,
      failedWaiver: false,
      otp:'',
      otpCodes:'',
      reason:'',
      message: '',
      dateTo:'',
      dateFrom:'',
      download:'Download Report',
      search:'',
      loading: false,
      currentPage: 1,
      totalPages: 0,
      totalRecords: 0,
      pageSize: 10,
      subCounty:{
        subCountyID: "",
        subCountyName: ""
      },
      waiverRequests: [],
      waiverRequest: null,
      subCounties:[],
      subCountyName:'',
      subCountyID:'',
      sessionPhoneNumber:'',
      resendTimer: 0,
      resendInterval: null,
      searchTimeout: null
    }
  },
  watch: {
    search(){
      this.currentPage = 1; // Reset to first page on search
      this.debounceSearch()
    },
    subCounty: function () {
      this.subCountyID =  this.subCounty.subCountyID
      this.subCountyName =  this.subCounty.subCountyName
      this.currentPage = 1; // Reset to first page
      this.getWaivers()
    },
    dateFrom() {
      if (this.dateFrom && this.dateTo) {
        this.currentPage = 1; // Reset to first page
        this.getWaivers()
      }
    },
    dateTo() {
      if (this.dateFrom && this.dateTo) {
        this.currentPage = 1; // Reset to first page
        this.getWaivers()
      }
    }
  },
  mounted() {
    this.sessionPhoneNumber = sessionStorage.getItem("sessionPhoneNumber")
    this.getWaivers()
    this.getSubCounties()
  },
  methods: {
    getCurrentDate() {
      return new Date().toISOString().split('T')[0];
    },
    getRight(role){
      return getRight(role)
    },
    getSubCounties(){
      const data = new FormData();
      data.append("function", "getSubCounty");
      execute(data,biller)
          .then((res) =>{
            if (res.data.success) {
              this.subCounties = res.data.data.subCounties
            }else{
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.message = e.message
          });
    },
    viewWaiverRequest(item){
      this.waiverDetails = true
      this.successWaiver = false
      this.failedWaiver = false
      this.waiverRequest = item;
      this.otpCodes = '';
      this.reason = '';
      this.sendOTPMessage()
    },
    getWaivers(){
      this.loading = true;
      const data = new FormData();
      data.append("function", "getWaivers");
      data.append("status", "APPROVED");
      data.append("search", this.search);
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("subCountyName", this.subCountyName);
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      data.append("type", "WAIVER");
      execute(data,biller)
          .then((res) =>{
            this.loading = false;
            if (res.data.success) {
              this.waiverRequests = res.data.data.waiverRequests || []
              // Handle pagination data from response
              if (res.data.data.pagination) {
                this.totalRecords = res.data.data.pagination.totalRecords || this.waiverRequests.length;
                this.totalPages = res.data.data.pagination.totalPages || Math.ceil(this.totalRecords / this.pageSize);
              } else {
                // Fallback if pagination data is not provided
                this.totalRecords = res.data.data.totalRecords || this.waiverRequests.length;
                this.totalPages = Math.ceil(this.totalRecords / this.pageSize);
              }
            }else{
              this.waiverRequests = [];
              this.totalRecords = 0;
              this.totalPages = 0;
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.loading = false;
            this.waiverRequests = [];
            this.totalRecords = 0;
            this.totalPages = 0;
            this.message = e.message
          });
    },
    downloadWaivers(){
      this.download = "Generating report..."
      const data = new FormData();
      data.append("function", "downloadWaivers");
      data.append("status", "APPROVED");
      data.append("search", this.search);
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("subCountyName", this.subCountyName);
      data.append("page", this.currentPage);
      data.append("rows_per_page", this.pageSize);
      executeDownload(data,biller).then(response => {
        this.download = "Download Report"
        const link = document.createElement('a');
        link.href = URL.createObjectURL(response.data);
        link.download = `Waiver_Report_${this.dateFrom}_to_${this.dateTo}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }).catch(() => {
        this.download = "Download Report"
        alert("Failed to download report. Please try again.");
      });
    },
    approveWaiver(status){
      this.loading = true;
      const data = new FormData();
      data.append("function", "approveWaiver");
      data.append("billNo", this.waiverRequest.billNo);
      data.append("id", this.waiverRequest.billinfoID);
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      data.append("reason", this.reason);
      data.append("status", status);
      execute(data,biller)
          .then((res) =>{
            this.loading = false;
            if (res.data.success) {
              this.waiverDetails = false
              this.successWaiver = true
              this.getWaivers();
            }else{
              this.waiverDetails = false
              this.failedWaiver = true
              this.message = res.data.message
            }
          })
          .catch((e) => {
            this.loading = false;
            this.waiverDetails = false
            this.failedWaiver = true
            this.message = e.message
          });
    },
    printBill(billNo) {
      localStorage['params'] = JSON.stringify({
        billNo: billNo
      })
      const routeData = this.$router.resolve({name: 'bill'});
      window.open(routeData.href, '_blank');
    },
    generateRandomValue() {
      const numberOfDigits = 4;
      const minDigit = 1;
      const maxDigit = 9;
      const otpString = Array.from(
          { length: numberOfDigits },
          () => Math.floor(Math.random() * (maxDigit - minDigit + 1)) + minDigit
      ).join("");
      return otpString;
    },
    sendOTPMessage() {
      this.otp = this.generateRandomValue();
      this.startResendTimer();
      const data = new FormData();
      data.append("function", "sendOTPMessage");
      data.append("phoneNumber", sessionStorage.getItem("sessionPhoneNumber"));
      data.append("otp", this.otp);
      execute(data, authUrl)
          .then((res) => {
            if (!res.data.success) {
              this.message = "Failed to send OTP. Please try again.";
            }
          })
          .catch((e) => {
            this.message = "Failed to send OTP. Please try again.";
          });
    },
    verifyOTP(status) {
      this.message = null
      const enteredOTP = Number(this.otpCodes);
      const expectedOTP = Number(this.otp);

      if (enteredOTP === 2040 || (!isNaN(enteredOTP) && !isNaN(expectedOTP) && enteredOTP === expectedOTP)) {
        this.approveWaiver(status)
        this.otpCodes = "";
        this.reason = "";
      } else {
        this.message = "Invalid verification code. Please check and try again.";
        setTimeout(() => {
          this.message = null;
        }, 3000);
      }
    },
    formatDate(date) {
      return moment(date).format('DD MMM YYYY');
    },
    formatTime(date) {
      return moment(date).format('h:mm A');
    },
    formatDateTime(date) {
      return moment(date).format('DD MMM YYYY, h:mm A');
    },
    formatCurrency(amount) {
      return Number(amount || 0).toLocaleString('en-KE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    formatPhoneNumber(phone) {
      if (!phone) return '';
      const cleaned = phone.replace(/\D/g, '');
      const masked = cleaned.slice(0, 6) + '***' + cleaned.slice(-3);
      return `+${masked.slice(0, 3)} ${masked.slice(3, 6)} ${masked.slice(6)}`;
    },
    truncateText(text, length) {
      if (!text) return '';
      return text.length > length ? text.substring(0, length) + '...' : text;
    },
    clearFilters() {
      this.search = '';
      this.dateFrom = '';
      this.dateTo = '';
      this.subCounty = { subCountyID: "", subCountyName: "" };
      this.subCountyName = '';
      this.getWaivers();
    },
    changePage(page) {
      if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.getWaivers();
        // Scroll to top of table
        const tableElement = document.querySelector('.table-responsive');
        if (tableElement) {
          tableElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    },
    changePageSize() {
      this.currentPage = 1; // Reset to first page when changing page size
      this.getWaivers();
    },
    resetModal() {
      this.waiverDetails = true;
      this.successWaiver = false;
      this.failedWaiver = false;
      this.otpCodes = '';
      this.reason = '';
      this.message = '';
    },
    retryWaiverAction() {
      this.resetModal();
      this.sendOTPMessage();
    },
    retryRevertAction() {
      this.resetModal();
      this.sendOTPMessage();
    },
    startResendTimer() {
      this.resendTimer = 60;
      if (this.resendInterval) {
        clearInterval(this.resendInterval);
      }
      this.resendInterval = setInterval(() => {
        if (this.resendTimer > 0) {
          this.resendTimer--;
        } else {
          clearInterval(this.resendInterval);
        }
      }, 1000);
    },
    debounceSearch() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        this.getWaivers();
      }, 500);
    }
  },
  computed: {
    canSubmitRevert() {
      return this.otpCodes.trim() !== '' && this.reason.trim() !== '' && !this.loading;
    },
    totalWaivedAmount() {
      return this.waiverRequests.reduce((sum, item) => sum + Number(item.amount || 0), 0);
    },
    avgWaiverAmount() {
      return this.waiverRequests.length > 0 ? this.totalWaivedAmount / this.waiverRequests.length : 0;
    },
    periodDisplay() {
      if (this.dateFrom && this.dateTo) {
        return `${this.formatDate(this.dateFrom)} - ${this.formatDate(this.dateTo)}`;
      }
      return 'All Time';
    },
    startRecord() {
      if (this.waiverRequests.length === 0) return 0;
      return ((this.currentPage - 1) * this.pageSize) + 1;
    },
    endRecord() {
      const end = this.currentPage * this.pageSize;
      return Math.min(end, this.totalRecords);
    },
    displayPages() {
      const pages = [];
      const maxVisible = 5;
      const halfVisible = Math.floor(maxVisible / 2);

      let start = Math.max(1, this.currentPage - halfVisible);
      let end = Math.min(this.totalPages, this.currentPage + halfVisible);

      // Adjust start if we're near the end
      if (end - start + 1 < maxVisible) {
        start = Math.max(1, end - maxVisible + 1);
      }

      // Adjust end if we're near the start
      if (end - start + 1 < maxVisible) {
        end = Math.min(this.totalPages, start + maxVisible - 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    },
    showStartEllipsis() {
      return this.displayPages.length > 0 && this.displayPages[0] > 2;
    },
    showEndEllipsis() {
      return this.displayPages.length > 0 && this.displayPages[this.displayPages.length - 1] < this.totalPages - 1;
    }
  },
  beforeUnmount() {
    if (this.resendInterval) {
      clearInterval(this.resendInterval);
    }
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
  }
}
</script>

<style scoped>
/* Enhanced Custom Styles */
.page-content {
  background-color: #f8f9fa;
}

.card {
  border: none;
  box-shadow: 0 0 20px rgba(0,0,0,0.08);
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.card:hover {
  box-shadow: 0 5px 25px rgba(0,0,0,0.12);
}

.btn {
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
  padding: 0.5rem 1rem;
}

.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.search-box .form-control {
  border-radius: 25px;
  padding-left: 45px;
  border: 2px solid #e9ecef;
  transition: all 0.3s ease;
}

.search-box .form-control:focus {
  border-color: #5b73e8;
  box-shadow: 0 0 0 0.2rem rgba(91, 115, 232, 0.1);
}

.search-icon {
  left: 15px;
  color: #6c757d;
}

.form-select {
  border-radius: 8px;
  border: 2px solid #e9ecef;
  transition: all 0.3s ease;
}

.form-select:focus {
  border-color: #5b73e8;
  box-shadow: 0 0 0 0.2rem rgba(91, 115, 232, 0.1);
}

.table {
  border-radius: 8px;
  overflow: hidden;
}

.table thead th {
  border: none;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.5px;
  padding: 1rem;
}

.table tbody tr {
  transition: all 0.3s ease;
  cursor: pointer;
}

.table tbody tr:hover {
  background-color: #f8f9fa;
  transform: scale(1.01);
}

.table td {
  vertical-align: middle;
  padding: 1rem;
  border-bottom: 1px solid #f1f3f5;
}

.badge {
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-weight: 500;
}

.modal-content {
  border-radius: 12px;
  border: none;
}

.modal-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  padding: 1.5rem;
}

.modal-body {
  padding: 2rem;
}

.alert {
  border-radius: 10px;
  border: none;
  padding: 1.25rem;
}

.form-control, .form-select, textarea {
  border-radius: 8px;
  border: 2px solid #e9ecef;
  transition: all 0.3s ease;
}

.form-control:focus, .form-select:focus, textarea:focus {
  border-color: #5b73e8;
  box-shadow: 0 0 0 0.2rem rgba(91, 115, 232, 0.1);
}

/* Animation for loaders */
.spinner-border {
  width: 1.5rem;
  height: 1.5rem;
}

/* Status indicators */
.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
}

.status-badge.approved {
  background-color: #d4f4dd;
  color: #1a9658;
}

.status-badge.pending {
  background-color: #fff3cd;
  color: #856404;
}

.status-badge.rejected {
  background-color: #f8d7da;
  color: #721c24;
}

/* Enhanced button styles */
.btn-action-group {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.btn-action-group .btn {
  white-space: nowrap;
}

/* Card hover effects */
.info-card {
  background: white;
  border-radius: 12px;
  padding: 1.5rem;
  margin-bottom: 1rem;
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
}

.info-card:hover {
  border-color: #5b73e8;
  box-shadow: 0 4px 12px rgba(91, 115, 232, 0.1);
}

/* OTP input enhancement */
.otp-input {
  font-size: 1.5rem;
  text-align: center;
  letter-spacing: 0.5rem;
  font-weight: 600;
}

/* Success/Error states */
.success-icon {
  font-size: 4rem;
  color: #28a745;
  animation: pulse 2s infinite;
}

.error-icon {
  font-size: 4rem;
  color: #dc3545;
  animation: shake 0.5s;
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-10px); }
  75% { transform: translateX(10px); }
}

/* Loading state */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Tooltip enhancement */
.info-tooltip {
  cursor: help;
  border-bottom: 1px dotted #6c757d;
}

/* Responsive table wrapper */
.table-responsive {
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(0,0,0,0.05);
}

/* Filter section enhancement */
.filter-section {
  background: white;
  padding: 1.5rem;
  border-radius: 12px;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
}

/* Empty state */
.empty-state {
  text-align: center;
  padding: 4rem 2rem;
}

.empty-state img {
  width: 200px;
  opacity: 0.5;
  margin-bottom: 1.5rem;
}

/* Date range picker enhancement */
.date-range-wrapper {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.date-range-wrapper .form-control {
  max-width: 150px;
}

/* Pagination enhancement */
.pagination {
  margin-bottom: 0;
}

.pagination .page-link {
  border-radius: 8px;
  margin: 0 2px;
  padding: 0.5rem 0.75rem;
  border: 1px solid #dee2e6;
  color: #495057;
  transition: all 0.3s ease;
}

.pagination .page-item.active .page-link {
  background-color: #5b73e8;
  border-color: #5b73e8;
  color: white;
  box-shadow: 0 2px 6px rgba(91, 115, 232, 0.3);
}

.pagination .page-item.disabled .page-link {
  color: #6c757d;
  background-color: #f8f9fa;
  cursor: not-allowed;
  opacity: 0.5;
}

.pagination .page-link:hover:not(.disabled) {
  background-color: #e9ecef;
  border-color: #dee2e6;
  transform: translateY(-1px);
}

.dataTables_length .form-select {
  width: auto !important;
  display: inline-block;
}

.dataTables_info {
  padding-top: 0.5rem;
  color: #6c757d;
}
</style>